import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import DetailData from '../../pages/DetailAgent/components/DetailData';
import { get_agent_details } from '../../api/API';

const useStyles = makeStyles(() => ({
    root: {
        padding: '24px',
    },
}));

// export default function DetailAgent(props) {
//     const { className, ...rest } = props;

//     const classes = useStyles();
//     const [agents, setAgent] = useState();
  
//     useEffect(() => {
//       let mounted = true;
  
//       const fetchAgent = () => {
//         axios.get('/api/admindetails/1').then(response => {
//             if (mounted) {
//                 setAgent(response.data.admindetails);
//             }
//         });
//     };
  
//     fetchAgent();
  
//         return () => {
//             mounted = false;
//         };
//     }, []);
  
//     if (!agents) {
//         return null;
//     }

//     return (
//         <Grid
//             {...rest}
//             className={clsx(classes.root, className)}
//             container
//             spacing={3}
//         >
//             <Grid
//                 item
//                 lg={6}
//                 md={6}
//                 xl={4}
//                 xs={12}
//             >
//                 <DetailData agents={agents} />
//             </Grid>
            
//         </Grid>
//     )
// }

export default class DetailAgent extends React.Component {
    
    constructor(props){
        super(props);
        // console.log( this.props.match );

        this.state = {
            agents: null,
            agent_id: props.agent_id
        }
    }
  
    async get_data(){
        const postparam = {
            agent_id: this.state.agent_id
        }; 
       
        var json = await get_agent_details(postparam);
        if(json.status){
            console.log(json);
            this.setState({...this.state, agents : json.data });
        }
    }
 
    componentDidMount(){
        this.get_data();
    }

    render(){
        return (
            <Grid
                {...this.props}
                className={clsx(this.props.classes.root, this.props.className)}
                container
                spacing={3}
            >
                <Grid
                    item
                    lg={6}
                    md={6}
                    xl={4}
                    xs={12}
                >
                { this.state.agents ? 
                <DetailData classes={this.props.classes} agents={this.state.agents} /> : ''
                }
                </Grid>
                
            </Grid>
        )
    }
}




